module.exports = __webpack_public_path__ + "files/bulk-employees-payslips-template.xlsx";


//////////////////
// WEBPACK FOOTER
// ./files/bulk-employees-payslips-template.xlsx
// module id = 1137
// module chunks = 1